import type { AppConfig } from "@coinfallsmp/shared";
import { createContext, useContext, useEffect, useState } from "react";
import type { ReactNode } from "react";
import { getAppConfig } from "./api.js";

// Purely a UX convenience for hiding upload/avatar UI on a deployment that
// hasn't got R2 configured — never trusted for anything security-relevant;
// every R2-touching admin route independently refuses the request itself
// regardless of what this reports.
const AppConfigContext = createContext<AppConfig | null>(null);

export function AppConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<AppConfig | null>(null);

  useEffect(() => {
    getAppConfig()
      .then(setConfig)
      .catch(() => setConfig({ uploadsEnabled: false }));
  }, []);

  return <AppConfigContext.Provider value={config}>{children}</AppConfigContext.Provider>;
}

/** True only once we've confirmed the backend has R2 configured — defaults to false while loading or on error. */
export function useUploadsEnabled(): boolean {
  return useContext(AppConfigContext)?.uploadsEnabled ?? false;
}
